export const GENERAL = {
  email: "connect@verivistaadvisory.com",
  phone: "+91 87797 21987",
  phoneHref: "tel:+918779721987",
  whatsapp: "https://wa.me/918779721987?text=Hello%20VERIVISTA%2C%20I%27d%20like%20to%20share%20my%20resume%20for%20a%20career%20opportunity.",
  locations: "Mumbai · Delhi · Chennai · Hyderabad · Kolkata",
};

export const PARTNERS = [
  {
    id: "partner-1",
    name: "Suyog Madhukar Pulekar",
    role: "Managing Director",
    focus: "Commercial & Business Development",
    phone: "+91 88508 45977",
    phoneHref: "tel:+918850845977",
    email: "suyog@verivistaadvisory.com",
    whatsapp: "https://wa.me/918850845977?text=Hello%20VERIVISTA%2C%20I%27d%20like%20to%20discuss%20a%20production.",
    linkedin: "https://www.linkedin.com/in/suyog-pulekar-753bb25a",
  },
  {
    id: "partner-2",
    name: "Vaibhav Kashinath Choudhary",
    role: "Managing Director",
    focus: "Commercial & Client Relations",
    phone: "+91 96999 88055",
    phoneHref: "tel:+919699988055",
    email: "vaibhav@verivistaadvisory.com",
    whatsapp: "https://wa.me/919699988055?text=Hello%20VERIVISTA%2C%20I%27d%20like%20to%20discuss%20a%20production.",
    linkedin: "https://www.linkedin.com/in/vaibhav-choudhary-750b293a4",
  },
];

export const LEADERSHIP = {
  chairman: {
    name: "Sudhir Mhadu Chaudhari",
    title: "Managing Director",
    phone: "+91 90047 94011",
    phoneHref: "tel:+919004794011",
    email: "sudhir@verivistaadvisory.com",
    whatsapp: "https://wa.me/919004794011?text=Hello%20VERIVISTA%2C%20I%27d%20like%20to%20discuss%20a%20production.",
    linkedin: "https://www.linkedin.com/in/sudhir-chaudhari-9704057b",
  },
  executives: [
    {
      name: "Omkar Patil",
      title: "Managing Director",
      phone: "+91 98333 94428",
      phoneHref: "tel:+919833394428",
      email: "omkar@verivistaadvisory.com",
      whatsapp: "https://wa.me/919833394428?text=Hello%20VERIVISTA%2C%20I%27d%20like%20to%20discuss%20a%20production.",
      linkedin: "https://www.linkedin.com/in/omkar-patil-88349b17a",
    },
  ],
};

export const MARQUEE_ITEMS = [
  "Commercial Management",
  "Project Audit",
  "Production Accounting",
  "Tax Rebate Optimisation",
  "OTT Financial Compliance",
  "Multi-State Rebate Filing",
];

export const CHALLENGES = [
  {
    n: "01",
    title: "Budget Leakage",
    body: "Uncontrolled vendor rates, unchallenged overages and informal commitments quietly erode production margins long before anyone reconciles the ledger.",
  },
  {
    n: "02",
    title: "No Real-Time Visibility",
    body: "Producers see true cost position weeks after the money is spent. Decisions on reshoots, schedules and cash calls are made on stale numbers.",
  },
  {
    n: "03",
    title: "Audit Vulnerability",
    body: "Fragmented records, missing agreements, GST-non-compliant invoices and TDS lapses turn statutory audits and state rebate claims into disallowances and delays.",
  },
];

export const PILLARS = [
  {
    n: "I",
    title: "Commercial Management",
    body: "Deal architecture, vendor negotiation, contract discipline and cost governance from greenlight to delivery.",
    points: ["Budget structuring & cost control", "Vendor & crew contracting", "Cash-flow planning and cash calls"],
  },
  {
    n: "II",
    title: "Project Audit",
    body: "Independent, production-grade audit that stands up to financiers, studios, statutory authorities and state rebate bodies.",
    points: ["Concurrent transaction testing", "GST, TDS & disallowance defence", "State rebate certification support"],
  },
  {
    n: "III",
    title: "Project Accounting",
    body: "A dedicated project ledger, weekly cost reporting and disciplined settlement across every schedule, state and currency.",
    points: ["Project-wise books & controls", "Weekly cost reports to producers", "Final settlement & close-out"],
  },
];

export const DIFFERENCE_ROWS = [
  ["Accountant engaged after money is spent", "Control embedded before the first rupee moves"],
  ["Monthly statements, weeks late", "Weekly cost position, on schedule"],
  ["Audit as a year-end confrontation", "Audit as a continuous, quiet discipline"],
  ["Rebate claims assembled in a scramble", "Rebate-ready documentation from day one"],
  ["Three vendors, three versions of truth", "One ledger. One command. One truth."],
];

export const FLOW_STEPS = [
  { n: "01", title: "Greenlight", caption: "Budget architecture & controls locked" },
  { n: "02", title: "Pre-Production", caption: "Cash allocation, contracts, vendor terms" },
  { n: "03", title: "Principal Photography", caption: "Daily cost control & concurrent audit" },
  { n: "04", title: "Post-Production", caption: "Settlement, reconciliation & variance close" },
  { n: "05", title: "Final Audit & Rebate", caption: "Certified statements & state rebate filing" },
];

export const LIFECYCLE_PHASES = [
  {
    id: "phase-1",
    label: "Budget Approval",
    title: "Control begins before commitment",
    body: "We stress-test the budget, structure cost heads, set approval matrices and lock vendor rate cards before the shoot is announced.",
    deliverable: "Signed-off budget architecture & control matrix",
  },
  {
    id: "phase-2",
    label: "Weekly Cost Report",
    title: "Every week, the true number",
    body: "Producers receive a single-page cost position: spent, committed, projected final, and variance — every week, without fail.",
    deliverable: "Weekly producer cost report & cash forecast",
  },
  {
    id: "phase-3",
    label: "Cash Call Audit",
    title: "No cash call without evidence",
    body: "Every drawdown request is matched against contracts, deliverables and physical progress before funds are released.",
    deliverable: "Audited cash call certifications",
  },
  {
    id: "phase-4",
    label: "Tax Certificate",
    title: "Close clean, claim fully",
    body: "Final statements are certified, state rebates and subsidies are filed with fully compliant documentation, and the project closes without a residual tail.",
    deliverable: "Certified final accounts & state rebate filing pack",
  },
];

export const INDUSTRIES = [
  {
    id: "films",
    title: "Feature Films",
    body: "Theatrical and independent features — multi-schedule, multi-location financial control from prep to delivery.",
    img: "https://images.pexels.com/photos/13146229/pexels-photo-13146229.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "ott",
    title: "OTT & Web Series",
    body: "Platform-mandated cost reporting, delivery-linked milestones and broadcaster-grade audit trails.",
    img: "https://images.pexels.com/photos/8088386/pexels-photo-8088386.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "ads",
    title: "TVC & Ad Films",
    body: "High-velocity commercial productions where every shift, location and post hour is commercially governed.",
    img: "https://images.pexels.com/photos/23384400/pexels-photo-23384400.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "networks",
    title: "TV & Media Networks",
    body: "Continuing productions and live formats with rolling budgets, repeat vendors and episodic cost discipline.",
    img: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?q=80&w=1200&auto=format&fit=crop",
  },
];

export const VALUE_STATS = [
  { value: "₹750 Cr+", label: "Production budgets overseen across film, OTT, TV and advertising" },
  { value: "15+ Years", label: "Of hands-on experience in screen and media finance" },
  { value: "75+", label: "Accounting, audit and production assignments handled" },
];

export const BOOKING_URL =
  "https://wa.me/918850845977?text=Hello%20VERIVISTA%2C%20I%27d%20like%20to%20book%20a%2030-minute%20discovery%20call.";

export const FORMAT_OPTIONS = ["Feature Film", "OTT / Web Series", "TV / Broadcast", "TVC / Ad Film", "Other"];
export const BUDGET_OPTIONS = ["Under ₹1 Cr", "₹1–5 Cr", "₹5–25 Cr", "₹25–100 Cr", "Above ₹100 Cr"];
export const STAGE_OPTIONS = ["Development", "Pre-Production", "In Production", "Post-Production", "Completed / Audit"];
